import HeaderTheme from '../../../models/header-theme';
export function headerThemeDtoToHeaderTheme(themeDto) {
  return new HeaderTheme(themeDto.id, themeDto.colors, themeDto.headerImage, themeDto.headerLine1, themeDto.loginBackground);
}
